/**
 * Tipos para el historial de estados de orden (order-status-log).
 * Alineados con OrderStatusHistoryDto del backend.
 */
import type { IRelevantInfo } from './suscription/history.types';

export interface IOrderStatusSummary {
  id: number;
  name: string;
  description?: string | null;
}

export interface IResponsibleUser {
  userId: number;
  firstName: string;
  lastName: string;
}

export interface IOrderHistoryEventType {
  id: number;
  uuid?: string;
  name: string;
  description?: string | null;
}

export interface IOrderHistoryEvent {
  id: number;
  orderId: number;
  createdAt: string;
  eventType: IOrderHistoryEventType;
  shipmentId?: number | null;
  userId?: number | null;
  relevantInfo?: IRelevantInfo;
}

export interface IOrderStatusHistoryItem {
  id: number;
  orderId: number;
  orderStatusId: number;
  responsibleUserId?: number;
  createdAt: string;
  orderStatus: IOrderStatusSummary;
  nextOrderStatus: IOrderStatusSummary | null;
  responsibleUser?: IResponsibleUser | null;
  events?: IOrderHistoryEvent[];
}

/** Resumen de estado de envío (ShipmentStatus) */
export interface IShipmentStatusSummary {
  id: number;
  name: string;
  nameStringId?: string | null;
}

/** Item del historial de estados de un envío */
export interface IShipmentStatusHistoryItem {
  id: number;
  shipmentId: number;
  shipmentStatusId: number;
  createdAt: string;
  shipmentStatus: IShipmentStatusSummary;
  nextShipmentStatus: IShipmentStatusSummary | null;
}

export interface IOrderHistoryWithShipmentsResponse {
  orderHistory: IOrderStatusHistoryItem[];
  shipments: { shipmentId: number; history: IShipmentStatusHistoryItem[] }[];
}

/** Respuesta del endpoint last-update para el bloque Última actualización */
export interface IOrderStatusLogLastUpdate {
  orderStatusId: number;
  orderStatusName: string;
  createdAt: string;
  responsibleUser?: IResponsibleUser | null;
}

/**
 * Nombres visibles por ID de estado (OrderStatus en BD).
 * IDs 1-13 según orderstatuslog.
 */
export const ORDER_STATUS_LOG_NAMES: Record<number, string> = {
  1: 'Por confirmar',
  2: 'Confirmado',
  3: 'Cancelado',
  4: 'Entregado',
  5: 'Preparación',
  6: 'Tránsito A Bodega',
  7: 'En bodega',
  8: 'Tránsito al Destino',
  9: 'Parcialmente En Preparación',
  10: 'Parcialmente En Tránsito A Bodega',
  11: 'Parcialmente En Bodega',
  12: 'Parcialmente En Tránsito',
  13: 'Parcialmente Entregado'
};
